const FAQ_OPTIONS = [
  {
    question: "اسکارپین چیست؟",

    answer:
      "اسکارپین یک سامانه هوشمند درخصوص پایش سلامت خودرو با استفاده از الگوی مصرف قطعات و اقلام مصرفی خودرو می‌باشد. که می‌تواند نقش دستیار مناسب برای رانندگان را به‌منظور پایش لحظه‌ای وضعیت خودرو خود داشته باشد.",
  },
  {
    question: "سامانه اسکارپین چه خدماتی را به مالکان خودرو ارائه می‌دهد؟",
    answer:
      "ماکان خودرو با استفاده از اپلیکیشن اسکارپین می‌توانید وضعیت تمامی قطعات و اقلام مصرفی خودرو خود را پایش نموده و از سلامت خودرو خود اطمینان برقرار نمایند، همچنین مالکان خودرو می‌توانند خدماتی همچون؛ 1. خدمات بیمه‌ای، 2. خدمات سرویس در محل، 3. خدمات استعلامی، 4. خدمات تعمیر و تعویض قطعات خودرو و سایر خدمات مربوط به خودرو خود را از سامانه اسکارپین دریافت نمایید.",
  },
  {
    question:
      "آیا از طریق دسک‌تاپ و یا تبلت می‌تواند از خدمات اسکارپین استفاده نمود؟",
    answer:
      "شما می‌توانید به کمک وب اپلیکیشن اسکارپین با هر نوع تلفن هوشمند و یا سیستم شخصی که در اختیار دارید به سامانه اسکارپین متصل و از خدمات ارائه شده لذت ببرید. تنها کافی است به صفحه m.scarpin.ir رفته و گزینه «ورود به وب اپلیکیشن» را انتخاب نمایید و یا از این قسمت وب اپلیکیشن را راه‌اندازی و استفاده نمایید.",
  },
  {
    question: "آیا استفاده از خدمات و سامانه اسکارپین رایگان است؟",
    answer:
      "بله، تمامی خدمات ارائه شده برای مالکان خودرو که در اپلیکیشن اسکارپین حساب کاربری دارند، رایگان می‌باشد.",
  },
  {
    question: "اسکارپین را از کجا می‌توانم دانلود نمایم؟",
    answer:
      "شما می‌توانید نرم‌افزار اسکارپین را برای هر پلتفرمی که مدنظر دارید از این قسمت دانلود و استفاده نمایید.",
  },
  {
    question: "چگونه می‌توانم در سامانه اسکارپین حساب کاربری ایجاد نمایم؟",
    answer:
      "پس از نصب اپلیکیشن یا وب اپلیکیشن اسکارپین بر روی تلفن هوشمند و یا سایر دستگاه‌های خود، تنها کافیست شماره تلفن همراه خود و کد تأیید را وارد نمایید تا حساب کاربری اسکارپین برای شما ساخته شود.",
  },
  {
    question: "آیا می‌توان مشخصات حساب کاربری را ویرایش نمود؟",
    answer:
      "بله، شما می‌توانید در هر زمان مشخصات و اطلاعات پروفایل خود را تغییر داده و در سامانه اسکارپین به‌روزرسانی نمایید.",
  },
  {
    question: "چگونه می‌توانم خودرو خود را در سامانه اسکارپین ثبت نمایم؟",
    answer:
      "در صفحه نمایشگاه خودرو شما می‌توانید با وارد نمودن شماره پلاک خودرو و انتخاب گزینه ثبت در قسمت پایین صفحه، خودرو خود را در سامانه اسکارپین اضافه نمایید.",
  },
  {
    question: "آیا در اضافه نمودن خودرو محدودیت وجود دارد؟",
    answer:
      "خیر، شما می‌توانید تمامی خودروهای خود را به منظور پایش با ایجاد یک حساب کاربری در سامانه اسکارپین ثبت نمایید.",
  },
  {
    question: "کد اسکارپین مختص خودرو چیست؟",
    answer:
      "پس از ثبت و اضافه نمودن خودرو توسط مالکان در سامانه اسکارپین، یک کد یکتا ساخته شده و برای شناسایی به خودرو اطلاق می‌گردد که با عنوان کد اسکارپین شناخته می‌شود.",
  },
  {
    question: "آیا می‌توان اطلاعات مربوط به خودرو را ویرایش نمود؟",
    answer:
      "بله، شما می‌توانید در هر زمان مشخصات و اطلاعات خودرو خود را تغییر داده و در سامانه اسکارپین به‌روزرسانی نمایید.",
  },
  {
    question:
      "آیا اقلام مصرفی و قطعات خودرو در سامانه اسکارپین دسته‌بندی شده‌اند؟",
    answer:
      "بله، تمامی اقلام مصرفی و قطعات خودرو در سه دسته زمانی؛ 1. کوتاه مدت، 2. میان مدت، 3. بلندمدت در سامانه اسکارپین تقسیم‌بندی شده است",
  },
  {
    question:
      "منظور از کیلومتر فعلی خودرو چیست و چگونه می‌توان آن را ویرایش نمود؟",
    answer:
      "میزان مسافت طی شده توسط خودرو را کیلومتر فعلی خودرو می‌نامند، این کیلومتر مبنای محاسبات سامانه اسکارپین بوده و بایستی به‌طور منظم به‌روزرسانی گردد. ",
  },
  {
    question: "چگونه می‌توانم کیلومتر فعلی خودرو را ویرایش نمود؟",
    answer:
      "شما می‌توانید در قسمت بالای صفحه اصلی اپلیکیشن، مقدار کیلومتر فعلی درج شده را انتخاب نموده و ویرایش نمایید.",
  },
  {
    question: "منظور از کیلومتر تعویض قطعات خودرو چیست؟",
    answer:
      "کیلومتر خودرو در زمان مراجعه به تعمیرگاه به‌منظور انجام سرویس خودرو را کیلومتر تعویض قطعه سرویس شده می‌نامند.",
  },
  {
    question: "منظور از عمر قطعات خودرو چیست؟",
    answer:
      "به میزان مصرف قابل قبول و متداول اقلام مصرفی و قطعات خودرو، عمر قطعات گفته می‌شود که با واحد کیلومتر اندازه‌گیری می‌شوند.",
  },
  {
    question: "چگونه می‌توانم تعویض قطعات خودرو را در سامانه ثبت نمایم؟",
    answer:
      "شما می‌توانید با انتخاب هر قطعه خودرو و پس از هدایت شدن به صفحه مورد نظر در قسمت پایین صفحه با وارد نمودن کیلومتر تعویض و عمر قطعه، مشخصات تعویض قطعات خودرو خود را در سامانه ثبت نمایید.",
  },
  {
    question:
      "مقدار کیلومتر تعویض و عمر قطعه نمایش داده شده در صفحات قطعات خودرو چیست؟",
    answer:
      "مقدار کیلومتر تعویض و عمر سرویس قبلی قطعه مورد نظر که در سامانه اسکارپین ثبت شده است به صورت کم رنگ نمایش داده می‌شود.",
  },
  {
    question:
      "آیا می‌توان کیلومتر فعلی خودرو را کمتر از مقدار ذخیره شده در سامانه ثبت نمود؟ ",
    answer:
      "خیر، به‌دلیل آنکه کیلومتر فعلی بیان‌گر مسافت طی شده خودرو شما است و مبانی محاسبات سامانه اسکارپین نیز کیلومتر فعلی خودرو شماست بنابراین ثبت کیلومتر کمتر از مقدار ذخیره شده در سامانه امکان پذیر نمی‌باشد. همچنین توجه داشته باشید که درصورت انجام سرویس خودرو و ثبت اطلاعات مربوط به سرویس در سامانه، کیلومتر فعلی خودرو به صورت اتوماتیک تغییر پیدا کرده و با کیلومتری که قطعه سرویس و یا تعویض شده است هماهنگ می‌گردد",
  },
  {
    question:
      "نمایندگی‌های اسکارپین (تعمیرگاه‌های خودرو اسکارپین) در کدام شهرها فعال هستند؟",
    answer:
      "نمایندگی‌های فعال اسکارپین فعلا تنها در استان تهران مشغول به فعالیت می‌باشند. اسکارپین برای توسعه نمایندگی‌های خود در سرتاسر ایران عزیز برنامه دارد.",
  },
  {
    question: "چگونه می‌توانم با پشتیبانی ارتباط برقرار نمایم؟",
    answer:
      "شما می‌توانید با انتخاب گزینه پشتیبانی در قسمت پایین منو، با تیم پشتیبانی اسکارپین به صورت تماس تلفنی، ارسال پیام در شبکه‌های اجتماعی ارتباط برقرار نمایید، همچنین شما می‌توانید درخواست پشتیبانی خود را به سامانه ارسال نمایید تا تیم پشتیبانی با شما تماس بگیرند.",
  },
  {
    question: "چگونه می‌توانم اطلاعات کاملی در مورد اسکارپین داشته باشم؟",
    answer:
      "در قسمت پایین منو اپلیکیشن شما می‌توانید با عضویت در شبکه‌های اجتماعی، آشنایی کاملی با سامانه اسکارپین و خدمات آن داشته باشید. همچنین با مراجعه به قسمت پشتیبانی اپلیکیشن خود می‌توانید سؤالات خود را با ثبت تیکت (درخواست پشتیبانی) از کارشناسان و همکاران خود در اسکارپین بپرسید.",
  },
];

export { FAQ_OPTIONS };
